import axios from "axios";
import { API_HOST_URL } from "../../services/api";
import {
  GET_COURSE_TYPE_REQUEST,
  GET_COURSE_TYPE_SUCCESS,
  GET_HEAR_ABOUT_US_FAILURE,
  GET_HEAR_ABOUT_US_REQUEST,
  GET_HEAR_ABOUT_US_SUCCESS,
  GET_INTERESTS_FAILURE,
  GET_INTERESTS_REQUEST,
  GET_INTERESTS_SUCCESS,
} from "./ActionType";

const getInterestRequest = () => ({ type: GET_INTERESTS_REQUEST });
const getInterestSuccess = (interest) => ({
  type: GET_INTERESTS_SUCCESS,
  payload: interest,
});

const getInterestFailure = (error) => ({
  type: GET_INTERESTS_FAILURE,
  payload: error,
});

export const getInterests = () => async (dispatch) => {
  dispatch(getInterestRequest());
  try {
    const response = await axios.get(`${API_HOST_URL}/enums/interests`);

    dispatch(getInterestSuccess(response.data));
  } catch (error) {
    dispatch(getInterestFailure(error.message));
  }
};

const getHearAboutUsRequest = () => ({ type: GET_HEAR_ABOUT_US_REQUEST });
const getHearAboutUsSuccess = (hearAboutUs) => ({
  type: GET_HEAR_ABOUT_US_SUCCESS,
  payload: hearAboutUs,
});

const getHearAboutUsFailure = (error) => ({
  type: GET_HEAR_ABOUT_US_FAILURE,
  payload: error,
});

export const getHearAboutUs = () => async (dispatch) => {
  dispatch(getHearAboutUsRequest());
  try {
    const response = await axios.get(`${API_HOST_URL}/enums/heardAboutUs`);
    dispatch(getHearAboutUsSuccess(response.data));
  } catch (error) {
    dispatch(getHearAboutUsFailure(error.message));
  }
};

const getCourseTypesRequest = () => ({ type: GET_COURSE_TYPE_REQUEST });
const getCourseTypesSuccess = (courseType) => ({
  type: GET_COURSE_TYPE_SUCCESS,
  payload: courseType,
});
const getCourseTypesFailure = (error) => ({
  type: GET_COURSE_TYPE_REQUEST,
  payload: error,
});

export const getCourseTypes = () => async (dispatch) => {
  dispatch(getCourseTypesRequest());
  try {
    const response = await axios.get(`${API_HOST_URL}/enums/courseTypes`);
    dispatch(getCourseTypesSuccess(response.data));
  } catch (error) {
    dispatch(getCourseTypesFailure(error.message));
  }
};
